var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isOpen,
            "show-close": true,
            title: "Xoá dữ liệu trùng lặp",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "90%" },
                        attrs: {
                          size: "small",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "dd-MM-yyyy",
                          placeholder: "Chọn ngày",
                          clearable: true,
                        },
                        model: {
                          value: _vm.dataInput.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "date", $$v)
                          },
                          expression: "dataInput.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-collapse",
                        {
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.activeName,
                            callback: function ($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              attrs: { title: "Điểm danh", name: "attendance" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "container_options" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        loading: _vm.isLoading.checkAttendance,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkAttendanceDuplicate()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  KTra điểm danh\n                "
                                      ),
                                    ]
                                  ),
                                  _c("span", { staticClass: "element_count" }, [
                                    _vm._v(
                                      "KQ: " + _vm._s(_vm.count.attendance)
                                    ),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        disabled: !_vm.count.attendance,
                                        loading: _vm.isLoading.deleteAttendance,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteAttendanceDuplicate()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Xóa điểm danh\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "Nhận xét", name: "evaluate" } },
                            [
                              _c(
                                "div",
                                { staticClass: "container_options" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        loading: _vm.isLoading.checkEvaluate,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkEvaluateDuplicate()
                                        },
                                      },
                                    },
                                    [_vm._v("KTra nhận xét\n                ")]
                                  ),
                                  _c("span", { staticClass: "element_count" }, [
                                    _vm._v("KQ: " + _vm._s(_vm.count.evaluate)),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        disabled: !_vm.count.evaluate,
                                        loading: _vm.isLoading.deleteEvaluate,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteEvaluateDuplicate()
                                        },
                                      },
                                    },
                                    [_vm._v("Xóa nhận xét\n                ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "Mã QR", name: "qr_code" } },
                            [
                              _c(
                                "div",
                                { staticClass: "container_options" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        loading: _vm.isLoading.checkQrCode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkQrCodeDuplicate()
                                        },
                                      },
                                    },
                                    [_vm._v("KTra mã QR\n                ")]
                                  ),
                                  _c("span", { staticClass: "element_count" }, [
                                    _vm._v("KQ: " + _vm._s(_vm.count.qrCode)),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        disabled: !_vm.count.qrCode,
                                        loading: _vm.isLoading.deleteQrCode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteQrCodeDuplicate()
                                        },
                                      },
                                    },
                                    [_vm._v("Xóa mã QR\n                ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                  [
                    _c("i", { staticClass: "el-icon-circle-close" }),
                    _vm._v("\n          Đóng\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }